// Welcome carousel slide catalogue. Ordered intro a new user sees
// on first cold launch, after onboarding completes. Each entry:
//   id        stable key — used as the React key + analytics tag if
//             we ever add one
//   icon      lucide-react icon NAME (component map in
//             WelcomeCarousel.jsx)
//   titleKey  i18n key under welcome.slides.<id>.title
//   bodyKey   i18n key under welcome.slides.<id>.body
//
// Strings live in src/locales/{en,ar}/translation.js under welcome.*.
//
// New slide: append here, add the i18n keys, ship. Carousel handles
// pagination automatically.

export const WELCOME_SLIDES = [
  {
    id: 'intro',
    icon: 'Sparkles',
    titleKey: 'welcome.slides.intro.title',
    bodyKey:  'welcome.slides.intro.body',
  },
  {
    id: 'couples',
    icon: 'Heart',
    titleKey: 'welcome.slides.couples.title',
    bodyKey:  'welcome.slides.couples.body',
  },
  {
    id: 'tracking',
    icon: 'Activity',
    titleKey: 'welcome.slides.tracking.title',
    bodyKey:  'welcome.slides.tracking.body',
  },
  {
    id: 'feed',
    icon: 'Newspaper',
    titleKey: 'welcome.slides.feed.title',
    bodyKey:  'welcome.slides.feed.body',
  },
  {
    id: 'yours',
    icon: 'Settings',
    titleKey: 'welcome.slides.yours.title',
    bodyKey:  'welcome.slides.yours.body',
  },
]
